(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    #dialog = null;
    #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#dialog = this.querySelector('dialog');
      if (!this.#dialog) return;

      this.#dialog.addEventListener('click', this.#onBackdropClick);
      this.#dialog.addEventListener('cancel', this.#onCancel);
      this.addEventListener('click', this.#onClick);
      this.addEventListener('change', this.#onChange);
      document.addEventListener('submit', this.#onSubmit);
      document.addEventListener('click', this.#onTriggerClick);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.#onSubmit);
      document.removeEventListener('click', this.#onTriggerClick);
    }

    get #content() {
      return this.querySelector('[data-drawer-content]');
    }

    open() {
      if (!this.#dialog.open) this.#dialog.showModal();
    }

    close() {
      if (!this.#dialog.open || this.#dialog.classList.contains('is-closing')) return;

      if (this.#motion.matches) {
        this.#dialog.close();
        return;
      }

      this.#dialog.classList.add('is-closing');
      this.#dialog.querySelector('.pf-drawer__panel').addEventListener(
        'animationend',
        () => {
          this.#dialog.classList.remove('is-closing');
          this.#dialog.close();
        },
        { once: true }
      );
    }

    #onBackdropClick = (event) => {
      if (event.target === this.#dialog) this.close();
    };

    #onCancel = (event) => {
      event.preventDefault();
      this.close();
    };

    #onTriggerClick = (event) => {
      const trigger = event.target.closest('a.pf-header__cart, [data-cart-drawer-open]');
      if (!trigger) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (window.location.pathname === this.dataset.cartUrl) return;

      event.preventDefault();
      this.open();
    };

    #onClick = (event) => {
      const target = event.target.closest('[data-close], [data-qty-minus], [data-qty-plus], [data-remove]');
      if (!target) return;

      if (target.hasAttribute('data-close')) {
        this.close();
        return;
      }

      const line = Number(target.dataset.line);
      const input = this.querySelector(`[data-qty-input][data-line="${line}"]`);
      const current = Number(input?.value ?? 0);

      if (target.hasAttribute('data-remove')) {
        this.#change(line, 0, `[data-remove][data-line="${line}"]`);
      } else if (target.hasAttribute('data-qty-plus')) {
        this.#change(line, current + 1, `[data-qty-plus][data-line="${line}"]`);
      } else {
        this.#change(line, Math.max(0, current - 1), `[data-qty-minus][data-line="${line}"]`);
      }
    };

    #onChange = (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;

      const line = Number(input.dataset.line);
      const quantity = Math.max(0, Math.floor(Number(input.value)) || 0);
      this.#change(line, quantity, `[data-qty-input][data-line="${line}"]`);
    };

    #onSubmit = async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (new URL(form.action, window.location.origin).pathname !== this.dataset.cartAddUrl) return;
      if (event.submitter?.getAttribute('name') === 'checkout') return;

      event.preventDefault();
      if (form.hasAttribute('aria-busy')) return;

      const button = event.submitter ?? form.querySelector('[type="submit"]');
      const label = button?.textContent;

      form.setAttribute('aria-busy', 'true');
      form.querySelector('.pf-form-error')?.remove();
      if (button) {
        button.disabled = true;
        button.textContent = this.dataset.textAdding;
      }

      try {
        const body = new FormData(form);
        body.append('sections', this.dataset.sectionId);
        body.append('sections_url', window.location.pathname);

        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'add failed');

        if (!this.#render(data.sections)) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }

        this.#showNotice(data);
        this.open();
      } catch (error) {
        const message = document.createElement('p');
        message.className = 'pf-form-error';
        message.setAttribute('role', 'alert');
        message.textContent = this.dataset.textAddError;
        form.append(message);
      } finally {
        form.removeAttribute('aria-busy');
        if (button) {
          button.disabled = false;
          button.textContent = label;
        }
      }
    };

    async #change(line, quantity, focusSelector) {
      const content = this.#content;
      content.classList.add('is-loading');
      content.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${this.dataset.cartChangeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line,
            quantity,
            sections: this.dataset.sectionId,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'change failed');
        if (!this.#render(data.sections)) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }

        const item = data.items?.[line - 1];
        if (quantity > 0 && item && item.quantity < quantity) {
          this.#showLineError(line, this.dataset.textOnlyAvailable.replace('__QTY__', String(item.quantity)));
        }
      } catch (error) {
        this.#showLineError(line, this.dataset.textChangeError);
      } finally {
        this.#content.classList.remove('is-loading');
        this.#content.removeAttribute('aria-busy');
        (this.querySelector(focusSelector) ?? this.querySelector('[data-close]'))?.focus();
      }
    }

    #render(sections) {
      const html = sections?.[this.dataset.sectionId];
      if (!html) return false;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-drawer-content]');
      if (!next) return false;

      this.#content.innerHTML = next.innerHTML;
      this.#syncHeaderCount();
      return true;
    }

    #syncHeaderCount() {
      const count = Number(this.querySelector('[data-cart-count]')?.dataset.cartCount ?? 0);
      const link = document.querySelector('.pf-header__cart');
      if (!link) return;

      let badge = link.querySelector('.pf-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'pf-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.append(badge);
        }
        badge.textContent = String(count);
      } else {
        badge?.remove();
      }

      link.setAttribute('aria-label', `${this.dataset.textCart}, ${this.#itemCount(count)}`);
    }

    /* A single add returns the item itself, adding several at once returns { items: [...] }. */
    #showNotice(data) {
      const slot = this.querySelector('[data-notice]');
      if (!slot) return;

      const added = Array.isArray(data.items) ? data.items : [data];
      if (added.length === 0) return;

      const notice = document.createElement('div');
      notice.className = 'pf-drawer__notice';
      notice.setAttribute('role', 'status');
      notice.innerHTML =
        "<span class='pf-drawer__notice-icon' aria-hidden='true'><svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' focusable='false'><path d='m5 12 5 5L20 7'/></svg></span>";

      const text = document.createElement('p');
      text.className = 'pf-drawer__notice-text';
      const strong = document.createElement('strong');
      strong.textContent = this.dataset.textAdded;
      const name = document.createElement('span');
      name.textContent = added.length > 1 ? this.#itemCount(added.length) : added[0].product_title;
      text.append(strong, name);

      notice.append(text);
      slot.replaceChildren(notice);

      for (const item of added) {
        const row = this.querySelector(`[data-key="${CSS.escape(item.key)}"]`);
        if (!row) continue;
        row.classList.add('is-added');
      }

      this.querySelector('.is-added')?.scrollIntoView({ block: 'nearest' });
    }

    #itemCount(count) {
      let category = 'other';
      try {
        category = new Intl.PluralRules(document.documentElement.lang || undefined).select(count);
      } catch (error) {}
      const key = `textCount${category.charAt(0).toUpperCase()}${category.slice(1)}`;
      const template = this.dataset[key] ?? this.dataset.textCountOther ?? '__COUNT__';
      return template.replace('__COUNT__', String(count));
    }

    #showLineError(line, message) {
      const error = this.querySelector(`[data-line="${line}"] [data-line-error]`);
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    for (const menu of document.querySelectorAll('.pf-header details[open]')) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openMenu = document.querySelector('.pf-header details[open]');
    if (!openMenu) return;

    for (const menu of document.querySelectorAll('.pf-header details[open]')) {
      menu.removeAttribute('open');
    }

    openMenu.querySelector('summary')?.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    #track = null;
    #slides = [];
    #dots = [];
    #toggle = null;
    #index = 0;
    #timer = null;
    #hovering = false;
    #focused = false;
    #userPaused = false;
    #observer = null;
    #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#track = this.querySelector('[data-track]');
      this.#slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.#track || this.#slides.length < 2) return;

      this.#dots = [...this.querySelectorAll('[data-dot]')];
      this.#toggle = this.querySelector('[data-toggle]');

      this.querySelector('[data-prev]')?.addEventListener('click', this.#onPrev);
      this.querySelector('[data-next]')?.addEventListener('click', this.#onNext);
      this.#toggle?.addEventListener('click', this.#onToggle);

      for (const dot of this.#dots) {
        dot.addEventListener('click', this.#onDot);
      }

      this.addEventListener('mouseenter', this.#onEnter);
      this.addEventListener('mouseleave', this.#onLeave);
      this.addEventListener('focusin', this.#onFocusIn);
      this.addEventListener('focusout', this.#onFocusOut);
      this.addEventListener('shopify:block:select', this.#onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.#onBlockDeselect);
      document.addEventListener('visibilitychange', this.#onVisibility);
      window.addEventListener('resize', this.#onResize);

      this.#observer = new IntersectionObserver(this.#onIntersect, {
        root: this.#track,
        threshold: 0.6
      });

      for (const slide of this.#slides) {
        this.#observer.observe(slide);
      }

      this.#start();
    }

    disconnectedCallback() {
      this.#stop();
      this.#observer?.disconnect();
      document.removeEventListener('visibilitychange', this.#onVisibility);
      window.removeEventListener('resize', this.#onResize);
    }

    #go(index, behavior) {
      const total = this.#slides.length;
      const next = (index + total) % total;

      this.#track.scrollTo({
        left: next * this.#track.clientWidth,
        behavior: behavior ?? (this.#motion.matches ? 'auto' : 'smooth')
      });
    }

    #setActive(index) {
      if (index < 0) return;
      this.#index = index;

      for (const [i, slide] of this.#slides.entries()) {
        slide.inert = i !== index;
      }

      for (const [i, dot] of this.#dots.entries()) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }
    }

    #start() {
      this.#stop();

      const canPlay =
        this.dataset.autoplay === 'true' &&
        !this.#userPaused &&
        !this.#hovering &&
        !this.#focused &&
        !this.#motion.matches &&
        !document.hidden;

      if (!canPlay) return;

      this.#track.setAttribute('aria-live', 'off');
      this.#timer = window.setInterval(() => this.#go(this.#index + 1), Number(this.dataset.interval) || 6000);
    }

    #stop() {
      window.clearInterval(this.#timer);
      this.#timer = null;
      this.#track?.setAttribute('aria-live', 'polite');
    }

    #onPrev = () => {
      this.#go(this.#index - 1);
      this.#start();
    };

    #onNext = () => {
      this.#go(this.#index + 1);
      this.#start();
    };

    #onDot = (event) => {
      this.#go(Number(event.currentTarget.dataset.slideIndex));
      this.#start();
    };

    #onToggle = () => {
      this.#userPaused = !this.#userPaused;
      this.#toggle.setAttribute('aria-pressed', String(this.#userPaused));
      this.#toggle.setAttribute(
        'aria-label',
        this.#userPaused ? this.#toggle.dataset.labelPlay : this.#toggle.dataset.labelPause
      );
      this.#start();
    };

    #onEnter = () => {
      this.#hovering = true;
      this.#stop();
    };

    #onLeave = () => {
      this.#hovering = false;
      this.#start();
    };

    #onFocusIn = () => {
      this.#focused = true;
      this.#stop();
    };

    #onFocusOut = (event) => {
      if (this.contains(event.relatedTarget)) return;
      this.#focused = false;
      this.#start();
    };

    #onVisibility = () => {
      this.#start();
    };

    #onResize = () => {
      this.#track.scrollTo({ left: this.#index * this.#track.clientWidth, behavior: 'auto' });
    };

    #onIntersect = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) this.#setActive(this.#slides.indexOf(entry.target));
      }
    };

    #onBlockSelect = (event) => {
      const slide = event.target.closest('[data-slide]');
      if (!slide) return;
      this.#stop();
      this.#go(this.#slides.indexOf(slide), 'auto');
    };

    #onBlockDeselect = () => {
      this.#start();
    };
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.setAttribute('data-enhanced', '');
      this.addEventListener('click', this.#onClick);
      this.addEventListener('change', this.#onChange);
    }

    get #content() {
      return this.querySelector('[data-cart-content]');
    }

    #onClick = (event) => {
      const target = event.target.closest('[data-qty-minus], [data-qty-plus], [data-remove]');
      if (!target) return;

      const line = Number(target.dataset.line);
      const input = this.querySelector(`[data-qty-input][data-line="${line}"]`);
      const current = Number(input?.value ?? 0);

      if (target.hasAttribute('data-remove')) {
        this.#change(line, 0, `[data-remove][data-line="${line}"]`);
      } else if (target.hasAttribute('data-qty-plus')) {
        this.#change(line, current + 1, `[data-qty-plus][data-line="${line}"]`);
      } else {
        this.#change(line, Math.max(0, current - 1), `[data-qty-minus][data-line="${line}"]`);
      }
    };

    #onChange = (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;

      const line = Number(input.dataset.line);
      const quantity = Math.max(0, Math.floor(Number(input.value)) || 0);
      this.#change(line, quantity, `[data-qty-input][data-line="${line}"]`);
    };

    async #change(line, quantity, focusSelector) {
      const content = this.#content;
      content.classList.add('is-loading');
      content.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${this.dataset.changeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line,
            quantity,
            sections: this.dataset.sectionId,
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'change failed');

        if (!this.#render(data.sections)) {
          window.location.reload();
          return;
        }

        const item = data.items?.[line - 1];
        if (quantity > 0 && item && item.quantity < quantity) {
          this.#showLineError(line, (this.dataset.textMaxQuantity || '').replace('[quantity]', item.quantity));
        }
      } catch (error) {
        this.#showLineError(line, this.dataset.textQuantityError || '');
      } finally {
        this.#content.classList.remove('is-loading');
        this.#content.removeAttribute('aria-busy');
        this.querySelector(focusSelector)?.focus();
      }
    }

    #render(sections) {
      const html = sections?.[this.dataset.sectionId];
      if (!html) return false;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cart-content]');
      if (!next) return false;

      this.#content.innerHTML = next.innerHTML;
      this.#syncHeaderCount();
      return true;
    }

    #syncHeaderCount() {
      const count = Number(this.querySelector('[data-cart-count]')?.dataset.cartCount ?? 0);
      const link = document.querySelector('.pf-header__cart');
      if (!link) return;

      let badge = link.querySelector('.pf-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'pf-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.append(badge);
        }
        badge.textContent = String(count);
      } else {
        badge?.remove();
      }

      const labels = {
        one: this.dataset.textCartOne,
        few: this.dataset.textCartFew,
        many: this.dataset.textCartMany,
        other: this.dataset.textCartOther
      };
      const category = new Intl.PluralRules(this.dataset.locale || undefined).select(count);
      link.setAttribute('aria-label', (labels[category] || labels.other || '').replace('[count]', count));
    }

    #showLineError(line, message) {
      const error = this.querySelector(`[data-line="${line}"] [data-line-error]`);
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionListing extends HTMLElement {
    #items = [];
    #state = null;
    #expanded = new Set();
    #benefits = null;
    #position = 3;
    #i18n = {};
    #locale = 'pl';

    connectedCallback() {
      this.#items = [...this.querySelectorAll('[data-item]')].map((element) => ({
        element,
        vendor: element.dataset.vendor || '',
        type: element.dataset.type || '',
        price: Number(element.dataset.price) || 0,
        available: element.dataset.available === 'true',
        discount: Number(element.dataset.discount) || 0,
        title: element.dataset.title || '',
        created: Number(element.dataset.created) || 0,
        index: Number(element.dataset.index) || 0
      }));
      if (this.#items.length === 0) return;

      this.#state = this.#defaults();
      this.#benefits = this.querySelector('[data-benefits]');
      this.#position = Number(this.dataset.benefitsPosition) || 3;
      this.#locale = this.dataset.locale || document.documentElement.lang || 'pl';
      try {
        this.#i18n = JSON.parse(this.dataset.i18n || '{}');
      } catch (error) {
        this.#i18n = {};
      }

      this.#buildOptions('vendor');
      this.#buildOptions('type');
      this.#setPriceBounds();

      this.addEventListener('change', this.#onChange);
      this.addEventListener('input', this.#onInput);
      this.addEventListener('click', this.#onClick);
      this.#render();
    }

    #text(key, values = {}) {
      let text = this.#i18n[key] ?? '';
      if (text && typeof text === 'object') {
        const forms = text;
        let rule = 'other';
        try {
          rule = new Intl.PluralRules(this.#locale).select(values.total ?? 0);
        } catch (error) {
          rule = 'other';
        }
        text = forms[rule] ?? forms.other ?? '';
      }
      return String(text).replace(/\[(\w+)\]/g, (match, name) => (name in values ? String(values[name]) : match));
    }

    #defaults() {
      return {
        vendor: new Set(),
        type: new Set(),
        reduced: false,
        instock: false,
        discount: 0,
        min: null,
        max: null,
        sort: 'manual',
        search: ''
      };
    }

    #buildOptions(group) {
      const list = this.querySelector(`[data-options='${group}']`);
      if (!list) return;

      const counts = new Map();
      for (const item of this.#items) {
        if (!item[group]) continue;
        counts.set(item[group], (counts.get(item[group]) || 0) + 1);
      }

      const values = [...counts.keys()].sort((a, b) => counts.get(b) - counts.get(a) || a.localeCompare(b, this.#locale));
      for (const value of values) {
        list.append(this.#createOption(group, value));
      }

      if (values.length < 2) this.querySelector(`[data-group-wrap='${group}']`)?.setAttribute('hidden', '');
    }

    #createOption(group, value) {
      const item = document.createElement('li');
      item.className = 'pf-filter__option';
      item.dataset.value = value;

      const label = document.createElement('label');
      label.className = 'pf-check';

      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = value;
      input.dataset.group = group;

      const text = document.createElement('span');
      text.className = 'pf-check__label';
      text.textContent = value;

      const count = document.createElement('span');
      count.className = 'pf-check__count';

      label.append(input, text, count);
      item.append(label);
      return item;
    }

    #setPriceBounds() {
      const prices = this.#items.map((item) => item.price / 100);
      const lowest = Math.floor(Math.min(...prices));
      const highest = Math.ceil(Math.max(...prices));
      const min = this.querySelector('[data-price-min]');
      const max = this.querySelector('[data-price-max]');
      if (min) min.placeholder = String(lowest);
      if (max) max.placeholder = String(highest);
    }

    /* An item passes when it matches every group. Pass `skip` to leave one group out (used for counts). */
    #matches(item, skip) {
      const s = this.#state;
      if (skip !== 'vendor' && s.vendor.size && !s.vendor.has(item.vendor)) return false;
      if (skip !== 'type' && s.type.size && !s.type.has(item.type)) return false;
      if (skip !== 'reduced' && s.reduced && item.discount <= 0) return false;
      if (skip !== 'instock' && s.instock && !item.available) return false;
      if (skip !== 'discount' && s.discount && item.discount < s.discount) return false;

      if (skip !== 'price') {
        const euros = item.price / 100;
        if (s.min !== null && euros < s.min) return false;
        if (s.max !== null && euros > s.max) return false;
      }

      return true;
    }

    #isFiltering() {
      const s = this.#state;
      return Boolean(s.vendor.size || s.type.size || s.reduced || s.instock || s.discount || s.min !== null || s.max !== null);
    }

    #comparator(sort) {
      switch (sort) {
        case 'price-asc':
          return (a, b) => a.price - b.price;
        case 'price-desc':
          return (a, b) => b.price - a.price;
        case 'title-asc':
          return (a, b) => a.title.localeCompare(b.title, this.#locale);
        case 'title-desc':
          return (a, b) => b.title.localeCompare(a.title, this.#locale);
        case 'newest':
          return (a, b) => b.created - a.created;
        default:
          return (a, b) => a.index - b.index;
      }
    }

    #render() {
      const s = this.#state;
      const shown = [];

      for (const item of this.#items) {
        const visible = this.#matches(item);
        item.element.hidden = !visible;
        if (visible) shown.push(item);
      }

      shown.sort(this.#comparator(s.sort));
      shown.forEach((item, rank) => {
        item.element.style.order = String(rank * 2);
      });

      if (this.#benefits) {
        this.#benefits.hidden = this.#isFiltering() || shown.length < this.#position;
        this.#benefits.style.order = String(this.#position * 2 - 1);
      }

      this.#renderFacets();
      this.#renderChips();

      const counter = this.querySelector('[data-count]');
      if (counter) {
        counter.textContent = this.#isFiltering() ? this.#text('filteredCount', { shown: shown.length, total: this.#items.length }) : counter.dataset.initial;
      }

      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = shown.length > 0;
    }

    #renderFacets() {
      const s = this.#state;

      for (const group of ['vendor', 'type']) {
        const counts = new Map();
        for (const item of this.#items) {
          if (item[group] && this.#matches(item, group)) counts.set(item[group], (counts.get(item[group]) || 0) + 1);
        }

        const options = [...this.querySelectorAll(`[data-options='${group}'] > li`)];
        const query = group === 'vendor' ? s.search : '';
        const expanded = this.#expanded.has(group);

        options.forEach((option, index) => {
          const input = option.querySelector('input');
          const total = counts.get(option.dataset.value) || 0;
          const matchesQuery = !query || option.dataset.value.toLowerCase().includes(query);
          const withinLimit = expanded || Boolean(query) || index < 6 || input.checked;

          option.querySelector('.pf-check__count').textContent = `(${total})`;
          option.classList.toggle('is-empty', total === 0 && !input.checked);
          input.disabled = total === 0 && !input.checked;
          option.hidden = !(matchesQuery && withinLimit);
        });

        const more = this.querySelector(`[data-more='${group}']`);
        if (more) {
          more.hidden = Boolean(query) || options.length <= 6;
          more.textContent = expanded ? this.#text('showLess') : this.#text('showMore');
        }
      }

      const countFor = (skip, test) => this.#items.filter((item) => this.#matches(item, skip) && test(item)).length;
      this.#setCount('reduced', countFor('reduced', (item) => item.discount > 0));
      this.#setCount('instock', countFor('instock', (item) => item.available));

      for (const input of this.querySelectorAll("input[data-group='discount']")) {
        const threshold = Number(input.value);
        const total = countFor('discount', (item) => item.discount >= threshold);
        this.#setCount(`discount-${threshold}`, total);
        input.disabled = total === 0 && !input.checked;
      }
    }

    #setCount(name, total) {
      const element = this.querySelector(`[data-count-for='${name}']`);
      if (element) element.textContent = `(${total})`;
    }

    #renderChips() {
      const holder = this.querySelector('[data-chips]');
      if (!holder) return;

      const s = this.#state;
      const chips = [];
      for (const value of s.vendor) chips.push({ kind: 'vendor', value, label: value });
      for (const value of s.type) chips.push({ kind: 'type', value, label: value });
      if (s.reduced) chips.push({ kind: 'reduced', value: '', label: this.#text('chipReduced') });
      if (s.instock) chips.push({ kind: 'instock', value: '', label: this.#text('chipInStock') });
      if (s.discount) chips.push({ kind: 'discount', value: '', label: this.#text('chipDiscount', { value: s.discount }) });
      if (s.min !== null || s.max !== null) {
        chips.push({ kind: 'price', value: '', label: this.#text('chipPrice', { min: s.min ?? 0, max: s.max ?? '∞' }) });
      }

      holder.replaceChildren();
      for (const chip of chips) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pf-chip';
        button.dataset.chipKind = chip.kind;
        button.dataset.chipValue = chip.value;
        button.setAttribute('aria-label', this.#text('removeFilter', { label: chip.label }));
        button.textContent = `${chip.label} ×`;
        holder.append(button);
      }

      if (chips.length > 0) {
        const reset = document.createElement('button');
        reset.type = 'button';
        reset.className = 'pf-chip pf-chip--reset';
        reset.dataset.reset = '';
        reset.textContent = this.#text('resetAll');
        holder.append(reset);
      }
    }

    #syncInputs() {
      const s = this.#state;

      for (const input of this.querySelectorAll('input[data-group]')) {
        const { group } = input.dataset;
        if (group === 'vendor' || group === 'type') input.checked = s[group].has(input.value);
        if (group === 'reduced') input.checked = s.reduced;
        if (group === 'instock') input.checked = s.instock;
        if (group === 'discount') input.checked = Number(input.value) === s.discount;
      }

      const min = this.querySelector('[data-price-min]');
      const max = this.querySelector('[data-price-max]');
      if (min) min.value = s.min ?? '';
      if (max) max.value = s.max ?? '';
    }

    #onChange = (event) => {
      const target = event.target;
      const s = this.#state;

      if (target.matches('input[data-group]')) {
        const { group } = target.dataset;

        if (group === 'vendor' || group === 'type') {
          if (target.checked) s[group].add(target.value);
          else s[group].delete(target.value);
        } else if (group === 'reduced') {
          s.reduced = target.checked;
        } else if (group === 'instock') {
          s.instock = target.checked;
        } else if (group === 'discount') {
          s.discount = target.checked ? Number(target.value) : 0;
          this.#syncInputs();
        }
      } else if (target.matches('[data-price-min], [data-price-max]')) {
        const parse = (value) => {
          const number = parseFloat(String(value).replace(',', '.'));
          return Number.isFinite(number) ? number : null;
        };
        s.min = parse(this.querySelector('[data-price-min]').value);
        s.max = parse(this.querySelector('[data-price-max]').value);
      } else if (target.matches('[data-sort]')) {
        s.sort = target.value;
      } else {
        return;
      }

      this.#render();
    };

    #onInput = (event) => {
      if (!event.target.matches('[data-vendor-search]')) return;
      this.#state.search = event.target.value.trim().toLowerCase();
      this.#render();
    };

    #onClick = (event) => {
      const toggle = event.target.closest('[data-toggle-filters]');
      if (toggle) {
        const open = this.querySelector('[data-panel]').classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        return;
      }

      const more = event.target.closest('[data-more]');
      if (more) {
        const { more: group } = more.dataset;
        if (this.#expanded.has(group)) this.#expanded.delete(group);
        else this.#expanded.add(group);
        this.#render();
        return;
      }

      if (event.target.closest('[data-reset]')) {
        const { sort } = this.#state;
        this.#state = this.#defaults();
        this.#state.sort = sort;
        this.#syncInputs();
        this.#render();
        return;
      }

      const chip = event.target.closest('[data-chip-kind]');
      if (chip) this.#removeChip(chip.dataset.chipKind, chip.dataset.chipValue);
    };

    #removeChip(kind, value) {
      const s = this.#state;

      if (kind === 'vendor' || kind === 'type') s[kind].delete(value);
      if (kind === 'reduced') s.reduced = false;
      if (kind === 'instock') s.instock = false;
      if (kind === 'discount') s.discount = 0;
      if (kind === 'price') {
        s.min = null;
        s.max = null;
      }

      this.#syncInputs();
      this.#render();
    }
  }

  if (!customElements.get('collection-listing')) {
    customElements.define('collection-listing', CollectionListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    #track = null;
    #slides = [];
    #thumbs = [];
    #prev = null;
    #next = null;
    #current = null;
    #lightbox = null;
    #stage = null;
    #image = null;
    #index = 0;
    #frame = 0;
    #drag = null;
    #suppressClick = false;
    #lbIndex = 0;
    #scale = 1;
    #tx = 0;
    #ty = 0;
    #pointer = null;
    #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#track = this.querySelector('[data-track]');
      if (!this.#track) return;

      this.#slides = [...this.querySelectorAll('[data-slide]')];
      this.#thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.#prev = this.querySelector('[data-prev]');
      this.#next = this.querySelector('[data-next]');
      this.#current = this.querySelector('[data-current]');
      this.#lightbox = this.querySelector('[data-lightbox]');
      this.#stage = this.querySelector('[data-stage]');
      this.#image = this.querySelector('[data-lb-image]');

      this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
      this.#track.addEventListener('pointerdown', this.#onTrackDown);
      this.#track.addEventListener('click', this.#onTrackClick);
      this.#track.addEventListener('dragstart', (event) => event.preventDefault());
      this.#track.addEventListener('keydown', this.#onTrackKeydown);
      this.#prev?.addEventListener('click', () => this.#go(this.#index - 1));
      this.#next?.addEventListener('click', () => this.#go(this.#index + 1));

      for (const thumb of this.#thumbs) {
        thumb.addEventListener('click', () => this.#go(Number(thumb.dataset.index)));
      }

      window.addEventListener('resize', this.#onResize);

      this.#initLightbox();
      this.#go(Number(this.dataset.startIndex) || 0, 'instant');
      this.#setActive(Number(this.dataset.startIndex) || 0);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.#onResize);
    }

    /* Called by the variant selector to show the variant's own image. */
    goToMedia(mediaId) {
      const index = this.#slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) this.#go(index);
    }

    /* ---------- Main gallery ---------- */

    #go(index, behavior) {
      const last = this.#slides.length - 1;
      const target = Math.min(Math.max(index, 0), last);

      this.#track.scrollTo({
        left: target * this.#track.clientWidth,
        behavior: behavior ?? (this.#motion.matches ? 'auto' : 'smooth')
      });
    }

    #setActive(index) {
      const last = this.#slides.length - 1;
      const next = Math.min(Math.max(index, 0), last);
      this.#index = next;

      for (const [i, thumb] of this.#thumbs.entries()) {
        if (i === next) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      }

      if (this.#current) this.#current.textContent = String(next + 1);
      if (this.#prev) this.#prev.disabled = next === 0;
      if (this.#next) this.#next.disabled = next === last;

      const thumb = this.#thumbs[next];
      const list = thumb?.closest('.pf-gallery__thumbs');
      if (thumb && list) {
        list.scrollTo({
          left: thumb.offsetLeft - (list.clientWidth - thumb.offsetWidth) / 2,
          behavior: this.#motion.matches ? 'auto' : 'smooth'
        });
      }
    }

    #onScroll = () => {
      if (this.#frame) return;

      this.#frame = window.requestAnimationFrame(() => {
        this.#frame = 0;
        const width = this.#track.clientWidth;
        if (width) this.#setActive(Math.round(this.#track.scrollLeft / width));
      });
    };

    #onResize = () => {
      this.#track.scrollTo({ left: this.#index * this.#track.clientWidth, behavior: 'instant' });
    };

    #onTrackKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#go(this.#index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#go(this.#index + 1);
      }
    };

    /* Mouse dragging (touch devices already swipe natively). */
    #onTrackDown = (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || this.#slides.length < 2) return;

      this.#drag = { x: event.clientX, left: this.#track.scrollLeft, start: this.#index, moved: false };
      window.addEventListener('pointermove', this.#onTrackMove);
      window.addEventListener('pointerup', this.#onTrackUp);
      window.addEventListener('pointercancel', this.#onTrackUp);
    };

    #onTrackMove = (event) => {
      const drag = this.#drag;
      if (!drag) return;

      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        this.#track.classList.add('is-dragging');
      }
      if (drag.moved) this.#track.scrollLeft = drag.left - dx;
    };

    #onTrackUp = (event) => {
      const drag = this.#drag;
      if (!drag) return;

      this.#drag = null;
      window.removeEventListener('pointermove', this.#onTrackMove);
      window.removeEventListener('pointerup', this.#onTrackUp);
      window.removeEventListener('pointercancel', this.#onTrackUp);

      if (!drag.moved) return;

      this.#suppressClick = true;
      window.setTimeout(() => {
        this.#suppressClick = false;
      }, 0);

      const dx = event.clientX - drag.x;
      let target = Math.round(this.#track.scrollLeft / this.#track.clientWidth);
      if (dx < -50) target = drag.start + 1;
      if (dx > 50) target = drag.start - 1;

      this.#track.classList.remove('is-dragging');
      this.#go(target);
    };

    #onTrackClick = (event) => {
      if (this.#suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const slide = event.target.closest('[data-slide]');
      if (slide) this.#openLightbox(Number(slide.dataset.index));
    };

    /* ---------- Fullscreen zoom view ---------- */

    #initLightbox() {
      if (!this.#lightbox || !this.#stage || !this.#image) return;

      this.querySelector('[data-lb-close]')?.addEventListener('click', () => this.#lightbox.close());
      this.querySelector('[data-lb-prev]')?.addEventListener('click', () => this.#step(-1));
      this.querySelector('[data-lb-next]')?.addEventListener('click', () => this.#step(1));
      this.querySelector('[data-zoom-in]')?.addEventListener('click', () => this.#zoomTo(this.#scale * 1.5, 0, 0));
      this.querySelector('[data-zoom-out]')?.addEventListener('click', () => this.#zoomTo(this.#scale / 1.5, 0, 0));

      this.#lightbox.addEventListener('keydown', this.#onLightboxKeydown);
      this.#lightbox.addEventListener('close', this.#onLightboxClose);
      this.#stage.addEventListener('pointerdown', this.#onStageDown);
      this.#stage.addEventListener('pointermove', this.#onStageMove);
      this.#stage.addEventListener('pointerup', this.#onStageUp);
      this.#stage.addEventListener('pointercancel', this.#onStageCancel);
      this.#stage.addEventListener('wheel', this.#onStageWheel, { passive: false });
    }

    #openLightbox(index) {
      if (!this.#lightbox) return;
      this.#show(index);
      this.#lightbox.showModal();
    }

    #show(index) {
      const slide = this.#slides[index];
      if (!slide) return;

      this.#lbIndex = index;
      this.#image.src = slide.dataset.zoomSrc;
      this.#image.alt = slide.dataset.zoomAlt || '';

      const counter = this.querySelector('[data-lb-current]');
      if (counter) counter.textContent = String(index + 1);

      const prev = this.querySelector('[data-lb-prev]');
      const next = this.querySelector('[data-lb-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === this.#slides.length - 1;

      this.#scale = 1;
      this.#tx = 0;
      this.#ty = 0;
      this.#apply();

      for (const neighbour of [this.#slides[index - 1], this.#slides[index + 1]]) {
        if (neighbour) new Image().src = neighbour.dataset.zoomSrc;
      }
    }

    #step(delta) {
      const next = this.#lbIndex + delta;
      if (next < 0 || next >= this.#slides.length) return;
      this.#show(next);
    }

    #apply() {
      this.#image.style.transform = `translate(${this.#tx}px, ${this.#ty}px) scale(${this.#scale})`;
      this.#stage.classList.toggle('is-zoomed', this.#scale > 1);
    }

    #clamp() {
      const width = this.#stage.clientWidth;
      const height = this.#stage.clientHeight;
      const naturalWidth = this.#image.naturalWidth || width;
      const naturalHeight = this.#image.naturalHeight || height;
      const fit = Math.min(width / naturalWidth, height / naturalHeight);
      const maxX = Math.max(0, (naturalWidth * fit * this.#scale - width) / 2);
      const maxY = Math.max(0, (naturalHeight * fit * this.#scale - height) / 2);

      this.#tx = Math.min(maxX, Math.max(-maxX, this.#tx));
      this.#ty = Math.min(maxY, Math.max(-maxY, this.#ty));
    }

    /* px and py are measured from the stage center, so the point under the cursor stays put. */
    #zoomTo(scale, px, py) {
      const from = this.#scale;
      const to = Math.min(4, Math.max(1, scale));

      this.#tx = px - (to * (px - this.#tx)) / from;
      this.#ty = py - (to * (py - this.#ty)) / from;
      this.#scale = to;

      if (to === 1) {
        this.#tx = 0;
        this.#ty = 0;
      }

      this.#clamp();
      this.#apply();
    }

    #centerOffset(event) {
      const rect = this.#stage.getBoundingClientRect();
      return {
        px: event.clientX - (rect.left + rect.width / 2),
        py: event.clientY - (rect.top + rect.height / 2)
      };
    }

    #onStageDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.#stage.setPointerCapture(event.pointerId);
      this.#pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, tx: this.#tx, ty: this.#ty, moved: false };
      this.#stage.classList.add('is-gesture');
    };

    #onStageMove = (event) => {
      const pointer = this.#pointer;
      if (!pointer || event.pointerId !== pointer.id) return;

      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;

      if (!pointer.moved && Math.hypot(dx, dy) > 5) {
        pointer.moved = true;
        if (this.#scale > 1) this.#stage.classList.add('is-panning');
      }
      if (!pointer.moved) return;

      if (this.#scale > 1) {
        this.#tx = pointer.tx + dx;
        this.#ty = pointer.ty + dy;
        this.#clamp();
      } else {
        this.#tx = dx;
      }
      this.#apply();
    };

    #onStageUp = (event) => {
      const pointer = this.#pointer;
      if (!pointer || event.pointerId !== pointer.id) return;

      this.#pointer = null;
      this.#stage.classList.remove('is-gesture', 'is-panning');

      if (!pointer.moved) {
        if (this.#scale > 1) {
          this.#zoomTo(1, 0, 0);
        } else {
          const { px, py } = this.#centerOffset(event);
          this.#zoomTo(2.5, px, py);
        }
        return;
      }

      if (this.#scale === 1) {
        const dx = event.clientX - pointer.x;
        this.#tx = 0;
        this.#apply();
        if (dx < -60) this.#step(1);
        if (dx > 60) this.#step(-1);
      }
    };

    #onStageCancel = () => {
      this.#pointer = null;
      this.#stage.classList.remove('is-gesture', 'is-panning');
      if (this.#scale === 1) this.#tx = 0;
      this.#apply();
    };

    #onStageWheel = (event) => {
      event.preventDefault();

      const { px, py } = this.#centerOffset(event);
      const speed = event.ctrlKey ? 0.01 : 0.0025;

      this.#stage.classList.add('is-gesture');
      this.#zoomTo(this.#scale * Math.exp(-event.deltaY * speed), px, py);
      window.clearTimeout(this.wheelTimer);
      this.wheelTimer = window.setTimeout(() => this.#stage.classList.remove('is-gesture'), 120);
    };

    #onLightboxKeydown = (event) => {
      switch (event.key) {
        case 'ArrowLeft':
          this.#step(-1);
          break;
        case 'ArrowRight':
          this.#step(1);
          break;
        case '+':
        case '=':
          this.#zoomTo(this.#scale * 1.5, 0, 0);
          break;
        case '-':
          this.#zoomTo(this.#scale / 1.5, 0, 0);
          break;
        case '0':
          this.#zoomTo(1, 0, 0);
          break;
        default:
          return;
      }

      event.preventDefault();
    };

    #onLightboxClose = () => {
      this.#go(this.#lbIndex, 'instant');
      this.#scale = 1;
      this.#tx = 0;
      this.#ty = 0;
    };
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
  class BundleProducts extends HTMLElement {
    async connectedCallback() {
      if (!this.querySelector('[data-bundle-card]')) {
        await this.#load('complementary');

        if (!this.querySelector('[data-bundle-card]') && this.dataset.fallback === 'true') {
          await this.#load('related');
        }
      }

      this.#init();
    }

    async #load(intent) {
      try {
        const response = await fetch(`${this.dataset.url}&intent=${intent}`);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('bundle-products');

        if (next?.querySelector('[data-bundle-card]')) this.innerHTML = next.innerHTML;
      } catch (error) {
        /* Recommendations are optional, so a failed request just leaves the section empty. */
      }
    }

    #init() {
      const form = this.querySelector('[data-bundle-form]');
      if (!form) return;

      form.addEventListener('change', this.#update);
      form.addEventListener('submit', this.#reindex);

      const select = document.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => this.#syncCurrent(select));

      this.#update();
    }

    #format(cents) {
      return new Intl.NumberFormat(this.dataset.locale || undefined, {
        style: 'currency',
        currency: this.dataset.currency || 'PLN'
      }).format(cents / 100);
    }

    #update = () => {
      let total = 0;

      for (const item of this.querySelectorAll('[data-bundle-item]')) {
        const toggle = item.querySelector('[data-bundle-toggle]');
        const included = toggle ? toggle.checked : true;
        const id = item.querySelector('[data-bundle-id]');
        const quantity = item.querySelector('[data-bundle-qty]');

        id.disabled = !included;
        quantity.disabled = !included;
        if (included) total += Number(id.dataset.priceCents);
      }

      const output = this.querySelector('[data-bundle-total]');
      if (output) output.textContent = this.#format(total);
    };

    /* Rename the fields in order so the cart gets a gap-free list of items. */
    #reindex = (event) => {
      let index = 0;

      for (const item of event.currentTarget.querySelectorAll('[data-bundle-item]')) {
        const id = item.querySelector('[data-bundle-id]');
        const quantity = item.querySelector('[data-bundle-qty]');
        if (id.disabled) continue;

        id.name = `items[${index}][id]`;
        quantity.name = `items[${index}][quantity]`;
        index += 1;
      }
    };

    /* Keep the "this item" entry in sync with the variant picked in the product form. */
    #syncCurrent(select) {
      const option = select.selectedOptions[0];
      const id = this.querySelector('[data-current]');
      if (!option || !id) return;

      id.value = select.value;
      id.dataset.priceCents = option.dataset.priceCents;

      const price = this.querySelector('[data-current-price]');
      if (price) price.textContent = option.dataset.price;

      const variant = this.querySelector('[data-current-variant]');
      if (variant) variant.textContent = option.dataset.variantTitle;

      this.#update();
    }
  }

  if (!customElements.get('bundle-products')) {
    customElements.define('bundle-products', BundleProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"]) return;
  try {
    
  class CompareProducts extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (this.querySelector('[data-table]')) {
        this.#init();
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#observer.disconnect();
          this.#load();
        },
        { rootMargin: '400px' }
      );
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    async #load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('compare-products');

        if (next?.querySelector('[data-table]')) {
          this.innerHTML = next.innerHTML;
          this.#init();
        }
      } catch (error) {
        /* The comparison is optional, so a failed request just leaves the section empty. */
      }
    }

    #init() {
      const table = this.querySelector('[data-table]');
      const toggle = this.querySelector('[data-toggle]');
      if (!table || !toggle) return;

      const visible = Number(this.dataset.visibleRows) || 5;
      const rows = [...table.tBodies[0].rows];
      rows.forEach((row, index) => row.classList.toggle('is-extra', index >= visible));

      if (rows.length <= visible) {
        rows.at(-1)?.classList.add('is-last');
        return;
      }

      const update = (collapsed) => {
        this.toggleAttribute('data-collapsed', collapsed);
        toggle.setAttribute('aria-expanded', String(!collapsed));
        toggle.querySelector('[data-toggle-label]').textContent = collapsed ? this.dataset.textMore || '' : this.dataset.textLess || '';
        toggle.querySelector('[data-toggle-icon]').style.rotate = collapsed ? '180deg' : '0deg';

        const shown = collapsed ? rows.slice(0, visible) : rows;
        rows.forEach((row) => row.classList.toggle('is-last', row === shown.at(-1)));
      };

      toggle.hidden = false;
      toggle.addEventListener('click', () => update(!this.hasAttribute('data-collapsed')));
      update(true);
    }
  }

  if (!customElements.get('compare-products')) {
    customElements.define('compare-products', CompareProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (this.querySelector('[data-related-track]')) {
        this.#init();
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#observer.disconnect();
          this.#load();
        },
        { rootMargin: '400px' }
      );
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    async #load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('related-products');

        if (next?.querySelector('[data-related-track]')) {
          this.innerHTML = next.innerHTML;
          this.#init();
        }
      } catch (error) {
        /* Recommendations are optional, so a failed request just leaves the section empty. */
      }
    }

    #init() {
      const track = this.querySelector('[data-related-track]');
      const prev = this.querySelector('[data-related-prev]');
      const next = this.querySelector('[data-related-next]');
      if (!track) return;

      const sync = () => {
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shelf"] && !Shopify.designMode) return;
  try {
    
  class ShelfCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      const arrows = this.querySelector('[data-arrows]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (!track) return;

      const sync = () => {
        const overflowing = track.scrollWidth > track.clientWidth + 1;
        if (arrows) arrows.hidden = !overflowing;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  if (!customElements.get('shelf-carousel')) {
    customElements.define('shelf-carousel', ShelfCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-buy"]) return;
  try {
    
  class StickyBuy extends HTMLElement {
    #mutations = null;
    #errors = null;

    connectedCallback() {
      /*
       * Find the product form by its class. Shopify gives sections a long generated id on the live
       * storefront (template--...__main), so an id selector written by hand would never match.
       */
      const form = document.querySelector('form.product-form');
      const mainQuantity = form?.querySelector("input[name='quantity']");
      const addButton = form?.querySelector('[data-add-to-cart]');

      const quantity = this.querySelector('[data-qty]');
      const addTarget = this.querySelector('[data-add]');
      const buyTarget = this.querySelector('[data-buy]');
      const errorTarget = this.querySelector('[data-error]');

      if (!form || !addButton || !quantity || !addTarget || !buyTarget) {
        this.hidden = true;
        return;
      }

      /* Quantity: keep the bar and the (hidden) field of the real product form in sync. */
      const clamp = (value) => Math.max(1, Math.floor(Number(value)) || 1);
      const setQuantity = (value) => {
        const next = clamp(value);
        quantity.value = String(next);
        if (mainQuantity) mainQuantity.value = String(next);
      };

      if (mainQuantity) quantity.value = String(clamp(mainQuantity.value));
      quantity.addEventListener('change', () => setQuantity(quantity.value));
      this.querySelector('[data-minus]').addEventListener('click', () => setQuantity(Number(quantity.value) - 1));
      this.querySelector('[data-plus]').addEventListener('click', () => setQuantity(Number(quantity.value) + 1));

      /*
       * Add to cart: click the real (hidden) button of the product form. That is exactly what a tap on it
       * does, so the cart drawer opens as on desktop. Without the drawer script the form simply submits.
       */
      addTarget.addEventListener('click', () => {
        errorTarget.hidden = true;
        setQuantity(quantity.value);
        addButton.click();
      });

      /* Buy now: add the selected variant and quantity, then go straight to checkout. */
      buyTarget.addEventListener('click', async () => {
        if (!form.reportValidity()) return;

        errorTarget.hidden = true;
        const label = buyTarget.textContent;
        buyTarget.dataset.busy = 'true';
        buyTarget.disabled = true;
        buyTarget.textContent = this.dataset.textLoading || label;

        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('add failed');
          window.location.assign(this.dataset.checkoutUrl);
        } catch (error) {
          errorTarget.textContent = this.dataset.textAddError || '';
          errorTarget.hidden = false;
          delete buyTarget.dataset.busy;
          buyTarget.disabled = false;
          buyTarget.textContent = label;
        }
      });

      /* Mirror price, compare price and button state from the main product form. */
      const price = document.querySelector('[data-product-price]');
      const compare = document.querySelector('[data-compare-price]');
      const priceTarget = this.querySelector('[data-price]');
      const compareTarget = this.querySelector('[data-compare]');

      const sync = () => {
        if (price && priceTarget) priceTarget.textContent = price.textContent;

        if (compare && compareTarget) {
          const text = compare.textContent.trim();
          compareTarget.textContent = text;
          compareTarget.hidden = compare.hidden || text === '';
        }

        addTarget.disabled = addButton.disabled;
        addTarget.textContent = addButton.textContent.trim();
        if (!buyTarget.dataset.busy) buyTarget.disabled = addButton.disabled;
      };

      this.#mutations = new MutationObserver(sync);
      for (const node of [price, compare, addButton]) {
        if (node) this.#mutations.observe(node, { childList: true, characterData: true, subtree: true, attributes: true });
      }

      /* The cart script shows add-to-cart errors under the form, which is out of sight on a phone. Show them in the bar. */
      this.#errors = new MutationObserver(() => {
        const message = form.querySelector('.pf-form-error');
        if (!message) return;
        errorTarget.textContent = message.textContent;
        errorTarget.hidden = false;
      });
      this.#errors.observe(form, { childList: true });

      sync();
    }

    disconnectedCallback() {
      this.#mutations?.disconnect();
      this.#errors?.disconnect();
    }
  }

  if (!customElements.get('sticky-buy')) {
    customElements.define('sticky-buy', StickyBuy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
  class ProductTabs extends HTMLElement {
    #tabs = [];

    connectedCallback() {
      this.#tabs = [...this.querySelectorAll("[role='tab']")];

      for (const tab of this.#tabs) {
        tab.addEventListener('click', () => this.#select(tab));
      }

      this.querySelector("[role='tablist']")?.addEventListener('keydown', this.#onKeydown);
      this.addEventListener('shopify:block:select', this.#onBlockSelect);
    }

    #select(selected, focus = false) {
      for (const tab of this.#tabs) {
        const active = tab === selected;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);

        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (panel) panel.hidden = !active;
      }

      selected.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focus) selected.focus();
    }

    #onKeydown = (event) => {
      const current = this.#tabs.indexOf(document.activeElement);
      if (current < 0) return;

      let next = -1;
      if (event.key === 'ArrowRight') next = (current + 1) % this.#tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.#tabs.length) % this.#tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.#tabs.length - 1;
      if (next < 0) return;

      event.preventDefault();
      this.#select(this.#tabs[next], true);
    };

    #onBlockSelect = (event) => {
      const tab = event.target.closest("[role='tab']");
      if (tab) this.#select(tab);
    };
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
